import React, { useCallback } from 'react';
import { Control, Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { trackFieldFocus } from '@/domain/job-application/helpers';
import { LIFormFieldValues, LOFormFieldValues } from '@/domain/job-application/types';
import { isValidEmail } from '@/helpers/validations';

import { FormField } from './form-fields.common.styles';

type Props = {
  control: Control<LOFormFieldValues | LIFormFieldValues>;
  isPrefilled?: boolean;
};

export const EmailField: React.VFC<Props> = ({ control, isPrefilled = false }) => {
  const intl = useIntl();
  const onEmailFocus = useCallback((): void => {
    trackFieldFocus({
      isAutofilled: isPrefilled,
      isMandatory: true,
      fieldName: 'email',
    });
  }, [isPrefilled]);

  return (
    <Controller
      name="email"
      control={control}
      render={({ field: { ref, ...fieldProps }, fieldState }) => (
        <FormField
          size="medium"
          label={intl.formatMessage({ id: 'JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_EMAIL_LABEL' })}
          data-cy="email"
          {...fieldProps}
          innerRef={ref}
          error={!!fieldState.error}
          helperText={
            fieldState?.error
              ? fieldState?.error?.type === 'required'
                ? intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_LO_EMAIL_FIELD_EMPTY_ERROR' })
                : intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_LO_EMAIL_FIELD_INVALID_ERROR' })
              : null
          }
          onFocus={onEmailFocus}
        />
      )}
      rules={{
        required: true,
        validate: isValidEmail,
      }}
    />
  );
};
